import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import 'react-s-alert/dist/s-alert-default.css';
import 'react-s-alert/dist/s-alert-css-effects/slide.css';
import 'primereact/resources/themes/lara-light-indigo/theme.css';    //theme
import 'primereact/resources/primereact.min.css';                    //core css
import 'primeicons/primeicons.css';                                  //icons
import reportWebVitals from './reportWebVitals';

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
